import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { Actions as ModalActions } from "@/store/modals/slice";

export const useTaskEditor = () => {
  const dispatch = useDispatch();
  return useCallback((params) => {
    dispatch(ModalActions.openCreateTask(params));
  }, []);
};
